import React from 'react';
import { Button } from '@ui-kitten/components';
import DNABox from '@alucio/lux-ui/src/components/layout/DNABox/DNABox';
import DNAIcon from '@alucio/lux-ui/src/components/visual/DNAIcon/DNAIcon';
const getIcon = (name, customIcon, style, rest) => (p) => {
    if (typeof name === 'string') {
        return (<DNAIcon {...p} style={[p.style, style]} name={name} testID={`icon-${name}`}/>);
    }
    // @ts-ignore [TODO] - Fix typing
    const width = style?.width || p?.style?.width;
    // @ts-ignore [TODO] - Fix typing
    const height = style?.height || p?.style?.height;
    return (<DNAIcon.Styled {...p} {...rest} style={[p.style, style]} name={name} testID={'icon-' + name} width={(typeof width === 'string' || typeof width === 'number') ? width : undefined} height={(typeof height === 'string' || typeof height === 'number') ? height : undefined} CustomIcon={customIcon}/>);
};
export const DNAButton = React.forwardRef(({ iconLeft, iconRight, customIconLeft, customIconRight, accessoryLeft, accessoryRight, children, iconStyle, testID, ...rest }, ref) => {
    const accessories = {
        accessoryLeft: iconLeft || customIconLeft
            ? getIcon(iconLeft, customIconLeft, iconStyle, rest)
            : accessoryLeft,
        accessoryRight: iconRight || customIconRight
            ? getIcon(iconRight, customIconRight, iconStyle, rest)
            : accessoryRight,
    };
    return (<DNABox ref={ref} testID={testID}>
      <Button {...accessories} {...rest}>
        {children}
      </Button>
    </DNABox>);
});
export default DNAButton;
//# sourceMappingURL=DNAButton.js.map